import { RefObject, useRef, useEffect } from "react";

interface IButtonProps {
  label: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

interface IDropdownProps {
  buttons: IButtonProps[];
  setIsDropdownOpen: (_: boolean) => void;
  isDropdownOpen: boolean;
  triggerRef?: RefObject<HTMLElement | null>;
  title?: string;
}

const DropdownWithModal = ({
  buttons,
  setIsDropdownOpen,
  isDropdownOpen,
  triggerRef,
  title,
}: IDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clickedOutside =
        dropdownRef.current &&
        !dropdownRef.current.contains(target) &&
        triggerRef?.current &&
        !triggerRef.current.contains(target);

      if (clickedOutside) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setIsDropdownOpen, triggerRef]);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-50">
          <div className="px-4 py-2 text-sm font-semibold text-gray-900 border-b border-gray-200">
            {title}
          </div>
          <div className="p-2">
            {buttons.map((button, index) => (
              <div
                key={index}
                className="flex items-center gap-2 hover:bg-gray-100 px-3 py-2 rounded cursor-pointer"
              >
                <div className="text-gray-700 flex items-center justify-center w-8 h-8">
                  {button.icon}
                </div>
                <button
                  className="w-full text-left text-sm leading-5 text-gray-700"
                  onClick={() => {
                    setIsDropdownOpen(false);
                    button.onClick?.();
                  }}
                >
                  {button.label}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownWithModal;
